import React, { useState } from 'react';
import Hero from '../components/Hero';
import AllocationInfo from '../components/AllocationInfo';
import Modal from '../components/Modal';
import SendFoxEmbed from '../components/SendFoxEmbed';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <Hero onOpenModal={() => setIsModalOpen(true)} />
      <AllocationInfo />
      <Footer />
      
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="text-center">
          <h3 className="font-serif text-2xl md:text-3xl text-white mb-4 tracking-wider">
            {t.joinWaitlist}
          </h3>
          <div className="w-12 h-[1px] bg-brand-gold mx-auto mb-8"></div>
          <SendFoxEmbed />
        </div>
      </Modal>
    </>
  );
}